<template>
  <section class="views">
    <!-- header -->
    <headers @viewUploadVideo="datumZZC = true"></headers>
    <!-- banner  -->
    <div class="posters">
      <van-image
        width="100%"
        :src="require('@/assets/image/hodgepodge/pcbanner.jpg')"
      />
      <div class="posters_ewm">
        <div class="ewm" @click="whatapp()">
          <div class="ewm2">
            <div class="ewm3">
              <img :src="require('@/assets/image/hodgepodge/ewm.png')" alt="" />
            </div>
            <div class="ewm3_value">
              <img :src="require('@/assets/image/wa.png')" alt="" /> 人工諮詢
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 举办方 -->
    <div class="organizers">
      <div class="box_uls">
        <div class="box_title_">
          <img
            :src="require('@/assets/image/hodgepodge/pctitle1.png')"
            alt=""
          />
        </div>
        <div class="box_zhuban">
          <div class="xiaoIconBox">
            <div
              v-for="(item, index) in sponsorIcon"
              :key="index"
              class="xiaoIconList"
            >
              <div v-if="index === 0" class="title_left">主辦機構：</div>
              <img :src="item.img" alt="" />
            </div>
          </div>
          <div class="xiaoIconTextBox">
            <div
              v-for="(item, index) in sponsorIcon"
              :key="'text-' + index"
              class="xiaoIconTextItem"
            >
              <span>{{ item.alt }}</span>
            </div>
          </div>
          <div class="zhuban">
            <div class="posters_text">
              <ul>
                <li v-for="(item, index) in sponsorArr" :key="index">
                  <div class="posters_text_left">
                    {{ item.leftValue }}
                    <div style="font-size: 12px; font-weight: 400">
                      {{ item.leftText }}
                    </div>
                  </div>
                  <div class="posters_text_right">{{ item.rightValue }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 時間軸 -->
    <div class="TimeAxis">
      <!-- 時間軸上面文字 -->
      <ul>
        <div class="time_xian_top">
          <li
            v-for="(item, index) in competitionTimeLine"
            :key="index"
            @click="stageBut(index)"
          >
            <!-- <div
              :class="item.select ? 'select' : 'cshhSelect'"
              v-if="!item.select"
            >
              {{ item.name }}
            </div> -->
            <img
              :src="
                require('@/assets/image/qp/' +
                  (item.index || index + 1) +
                  '.png')
              "
              alt=""
            />
          </li>
        </div>
      </ul>
      <!-- 時間軸 -->
      <ul>
        <div class="time_xian">
          <li
            v-for="(item, index) in competitionTimeLine"
            :key="index"
            @click="stageBut(index)"
          >
            <div class="xian">
              <span
                v-if="item.xuanSelect"
                :class="item.xuanSelect ? 'select' : ''"
                >{{ item.xuanSelect ? "當前階段" : "" }}</span
              >

              <span v-else></span>
              <!-- <span v-else :class="item.select ? 'span_t' : ''"></span> -->
            </div>
          </li>
        </div>
      </ul>
      <!-- 時間軸下面文字 -->
      <ul>
        <div class="time_xian_timeBox">
          <li
            v-for="(item, index) in competitionTimeLine"
            :key="index"
            v-html="item.tiem"
            @click="stageBut(index)"
          ></li>
        </div>
      </ul>
      <!-- 時間軸 -->
      <ul v-if="false">
        <div class="time_xian_fuchuang">
          <li v-for="(item, index) in competitionTimeLine" :key="index">
            <template v-if="item.select">
              <div class="list">
                <h1>{{ item.content.title }}</h1>
                <div class="p_xian" v-html="item.content.value"></div>
                <!-- <div
                  class="butom"
                  v-if="item.xuanSelect && index == 0 && currentCompetition === '1'"
                  @click="aheftBut()"
                >
                  <div class="buttomBut">在線報名</div>
                </div> -->
              </div>
            </template>
          </li>
        </div>
      </ul>
    </div>

    <!-- 参赛资格 -->
    <div class="viewBoxContent">
      <div class="box_uls">
        <div class="box_title">
          <img :src="require('@/assets/image/homeTitle/cszg.png')" alt="" />
        </div>
        <div class="box_centent cszg2">
          <div class="cszg2_list">
            <div style="text-align: left; font-weight: 600">（一）參賽資格</div>
            <ul>
              <li
                v-for="(item, index) in competitionQualifying.info"
                :key="index"
                v-html="item"
              ></li>
            </ul>
          </div>
          <div class="cszg2_uls">
            <div style="text-align: left; font-weight: 600">（二）組別</div>
            <div class="cszg_table isChinese">
              <table class="table-wrap">
                <thead>
                  <tr>
                    <th colspan="2">幼稚園</th>
                    <th colspan="3">小學</th>
                    <th>中學</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>初級組<br />K1-K2</td>
                    <td>高級組<br />K3</td>
                    <td>初級組<br />P1-P2</td>
                    <td>中級組<br />P3-P4</td>
                    <td>高級組<br />P5-P6</td>
                    <td>中學組<br />S1-S6</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="cszg_table">
              <table class="table-wrap">
                <thead>
                  <tr>
                    <th colspan="3">非華裔</th>
                    <th>特殊學校</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>飛躍-幼稚園組</td>
                    <td>飛躍-小學組</td>
                    <td>飛躍-中學組</td>
                    <td>閃亮組</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 報名確定 -->
    <div class="viewBoxContent">
      <div class="box_uls">
        <div class="box_title">
          <img :src="require('@/assets/image/homeTitle/csxz.png')" alt="" />
        </div>
        <div class="box_centent bxxq">
          <div class="bxxq_title">報名方法</div>

          <div class="bxxq_centent">
            <table class="bxxq-table-wrap">
              <tbody>
                <tr>
                  <td rowspan="2" style="font-weight: 600; width: 120px">
                    個人學生
                  </td>
                  <td colspan="2">
                    <div>網頁報名</div>
                    <div>
                      <span class="link_not_allowed" title="報名已結束">
                        報名已結束
                      </span>
                      <!-- <span class="show-link" @click="$router.push('/signup')">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 16 16"
                          fill="none"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path
                            d="M2 8h12"
                            stroke="#ff782f"
                            stroke-width="1.8"
                            stroke-linecap="round"
                          />
                          <path
                            d="M10 4l4 4-4 4"
                            stroke="#ff782f"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        立即登記
                      </span> -->
                    </div>
                  </td>
                  <td colspan="2">
                    <div>App報名</div>
                    <div>
                      <!-- <span class="link_not_allowed" title="暫未開放報名">立即下載</span> -->
                      <a
                        class="show-link"
                        href="https://app.chineserd.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 16 16"
                          fill="none"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path
                            d="M2 8h12"
                            stroke="#ff782f"
                            stroke-width="1.8"
                            stroke-linecap="round"
                          />
                          <path
                            d="M10 4l4 4-4 4"
                            stroke="#ff782f"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        立即下載
                      </a>
                    </div>
                  </td>
                </tr>
                <tr v-if="false">
                  <!-- 隐藏1 -->
                  <td>圖1</td>
                  <td>視頻1</td>
                  <td>圖2</td>
                  <td>視頻2</td>
                </tr>
                <tr>
                  <td colspan="4" style="text-align: left">
                    <div style="font-weight: 600">*注意：</div>
                    <p>
                      ①
                      個人學生應留意：同一電話號碼僅可用於3位或以下的參賽學生報名。
                    </p>
                    <p>
                      ② 中文路之在讀學生，請先更新App，即可在app内完成報名。
                    </p>
                  </td>
                </tr>
                <tr>
                  <td rowspan="6">
                    <div style="font-weight: 600">學校報名</div>
                    <div
                      style="
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 20px;
                        padding: 0 5px;
                      "
                    >
                      <a
                        class="show-link"
                        href="https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2026-01/daccda2fadabe0a38034c04797e4953f.pdf"
                        target="_blank"
                      >
                      <svg
                          width="14"
                          height="14"
                          viewBox="0 0 16 16"
                          fill="none"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path
                            d="M2 8h12"
                            stroke="#ff782f"
                            stroke-width="1.8"
                            stroke-linecap="round"
                          />
                          <path
                            d="M10 4l4 4-4 4"
                            stroke="#ff782f"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        學校集體報名操作指引
                      </a>
                    </div>
                  </td>
                  <td colspan="2">
                    <div>1.登記學校信息</div>
                    <div>
                      <!-- <span class="link_not_allowed" title="暫未開放報名">立即登記</span> -->
                      <span class="show-link" @click="goToSchoolInfo()">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 16 16"
                          fill="none"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path
                            d="M2 8h12"
                            stroke="#ff782f"
                            stroke-width="1.8"
                            stroke-linecap="round"
                          />
                          <path
                            d="M10 4l4 4-4 4"
                            stroke="#ff782f"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        立即登記
                      </span>
                    </div>
                  </td>
                  <td colspan="2">
                    <div>2.大會開通並發放賬戶</div>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    <div>3.通過網頁連結登入平台</div>
                    <div>
                      <!-- <span class="link_not_allowed" title="暫未開放報名">登入平台</span> -->
                      <span class="show-link" @click="homeToLogin()">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 16 16"
                          fill="none"
                          aria-hidden="true"
                          focusable="false"
                        >
                          <path
                            d="M2 8h12"
                            stroke="#ff782f"
                            stroke-width="1.8"
                            stroke-linecap="round"
                          />
                          <path
                            d="M10 4l4 4-4 4"
                            stroke="#ff782f"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        登入平台
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">4.老師可選以下其中一種方式登記報名</td>
                </tr>
                <tr>
                  <td colspan="2" style="text-align: left">
                    <div>方式一：</div>
                    <p>① 下載報名比賽二維碼（含通告）給學生/家長自行報名；</p>
                  </td>
                  <td colspan="2" style="text-align: left">
                    <div>方式二：</div>
                    <p>① 下載並填寫，然後上載參賽學生表格；</p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="text-align: left">
                    <p>
                      ② 學生/家長自行下載中文路App及登入【校園賬戶】參與比賽。
                    </p>
                  </td>
                  <td colspan="2" style="text-align: left">
                    <p>
                      ②
                      通知學生/家長，下載中文路App及登入【校園賬戶】並參與比賽。
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" style="text-align: left">
                    <div style="font-weight: 600">*注意：</div>
                    <p>掃碼報名截止時間：</p>
                    <div style="color: #f97226; font-weight: 600">
                      2026年3月8日 20:00 前
                    </div>
                  </td>
                  <td colspan="2" style="text-align: left">
                    <div style="font-weight: 600">*注意：</div>
                    <p>學校/機構提交報名表截止時間：</p>
                    <div style="color: #f97226; font-weight: 600">
                      2026年3月4日 20:00 前
                    </div>
                  </td>
                </tr>
                <tr v-if="false">
                  <!-- 隐藏1 -->
                  <td>圖1</td>
                  <td>視頻1</td>
                  <td>圖2</td>
                  <td>視頻2</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="bxxq_title">報名確認</div>
          <div class="bxxq_centent">
            <ol>
              <li>
                當中文路收妥報名表並審核無誤後，3個工作天內便會向參賽學生發出報名成功確認電郵。參賽學生應細閱電郵內的一切注意事項。
              </li>
              <li>
                請報名的參賽學生時刻留意主辦方的聯絡資訊（包括但不限於：SMS短信、E-mail郵件、電話或WhatsApp等），如錯過主辦方發出的通知資訊所導致的問題主辦方概不負責。
              </li>
            </ol>
          </div>

          <div class="bxxq_title">注意事項</div>
          <div class="bxxq_centent" style="margin-bottom: 8px">
            <ol>
              <li>
                所有比賽階段的表演者必須為參賽學生本人，如審核發現非參賽學生本人錄製或出席現場比賽之情況，將被取消參賽資格，予以失格公示。
              </li>
              <li>
                凡是報名比賽的參賽學生，等同於同意主辦方將其參賽影片使用在不同渠道媒體進行展示宣傳。
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- 比賽階段 -->
    <div class="viewBoxContent">
      <div class="box_uls">
        <div class="box_title">
          <img :src="require('@/assets/image/homeTitle/bsjd.png')" alt="" />
        </div>
        <div class="box_centent cszg">
          <table class="guidance-table-wrap">
            <tbody>
              <tr>
                <td rowspan="5" style="font-weight: 600">初賽</td>
                <td colspan="4">
                  <p>以中文路App： AI 語音評測系統進行海選</p>
                  <p style="font-weight: 600">每位參賽學生有5次參賽機會</p>
                  <span
                    >*參賽學生可於【我要練習】板塊中，不限次數練習，請注意練習成績僅供參考。</span
                  >
                </td>
              </tr>
              <tr>
                <td colspan="2" style="text-align: left">
                  <div class="app_login">
                    登入App：<img
                      src="@/assets/image/icon/logo_app.png"
                      alt=""
                    /><span style="font-weight: 600">ChineseRd Plus</span>
                  </div>
                  <div>
                    <span style="font-weight: 600">下載連結：</span
                    ><a
                      class="show-link"
                      href="https://app.chineserd.com/"
                      target="_blank"
                      >https://app.chineserd.com/</a
                    >
                  </div>
                </td>
                <td colspan="2">
                  <img
                    style="max-width: 150px"
                    src="@/assets/image/app_chineserd.png"
                    alt=""
                  />
                  <div>掃描 QR Code 下載App</div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div>
                    <p style="font-weight: 600">學生</p>
                    <p>自行報名</p>
                  </div>
                </td>
                <td colspan="2">
                  <div>
                    <p style="font-weight: 600">學校</p>
                    <p>集體報名</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div class="guide-thumb">
                    <img
                      :src="require('@/assets/image/Personal_guide.jpg')"
                      alt="指引圖1"
                      @click="
                        handleShowGuide(
                          'img',
                          require('@/assets/image/Personal_guide.jpg')
                        )
                      "
                    />
                  </div>
                </td>
                <!-- <td>視頻1</td> -->
                <td colspan="2">
                  <div class="guide-thumb">
                    <img
                      :src="require('@/assets/image/school_guide.jpg')"
                      alt="指引圖2"
                      @click="
                        handleShowGuide(
                          'img',
                          require('@/assets/image/school_guide.jpg')
                        )
                      "
                    />
                  </div>
                </td>
                <!-- <td>視頻2</td> -->
              </tr>
              <tr>
                <td colspan="4">
                  <p style="font-weight: 600; color: #3e7eec">
                    每完成1次語音評測，參賽學生即獲1次抽獎機會（最高5次）
                  </p>
                  <div>
                    <a
                      class="show-link"
                      href="https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/dc1cb7a1213a86b6e868e4daf7979ec3.pdf"
                      target="_blank"
                      ><svg
                        width="14"
                        height="14"
                        viewBox="0 0 16 16"
                        fill="none"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          d="M2 8h12"
                          stroke="#ff782f"
                          stroke-width="1.8"
                          stroke-linecap="round"
                        />
                        <path
                          d="M10 4l4 4-4 4"
                          stroke="#ff782f"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      抽獎細則
                    </a>
                  </div>
                </td>
              </tr>
              <!-- 复赛 -->
              <tr>
                <td rowspan="1" style="font-weight: 600">複賽</td>
                <td colspan="4">
                  <p>錄製朗誦影片，</p>
                  <p>並在 網頁 或 中文路App提交</p>
                </td>
              </tr>
              <tr v-if="false">
                <!-- 隐藏1 -->
                <td colspan="2">
                  <div>
                    <p>網頁提交</p>
                  </div>
                </td>
                <td colspan="2">
                  <div>
                    <p>App提交</p>
                  </div>
                </td>
              </tr>
              <tr v-if="false">
                <!-- 隐藏1 -->
                <td>圖1</td>
                <td>視頻1</td>
                <td>圖2</td>
                <td>視頻2</td>
              </tr>
              <!-- 决赛 -->
              <tr>
                <td rowspan="4" style="font-weight: 600">決賽</td>
                <td colspan="4">
                  <div>
                    將於<span style="font-weight: 600">
                      東華三院曾憲備小學 </span
                    >進行<span style="font-weight: 600; color: #3e7eec"
                      >現場比賽</span
                    >
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">選出金獎、銀獎、銅獎、優異獎</td>
              </tr>
              <tr>
                <td colspan="4">最佳造型獎、最佳語音獎、最佳台風獎</td>
              </tr>
              <tr>
                <td colspan="4">優秀指導老師獎</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 奖项及证书 -->
    <div class="viewBoxContent" style="margin-bottom: 20px">
      <div class="box_uls">
        <div class="box_title">
          <img :src="require('@/assets/image/homeTitle/csjx.png')" alt="" />
        </div>

        <div class="awards-box">
          <table class="awards-table-wrap">
            <tbody>
              <tr>
                <td style="font-weight: 600">電子證書</td>
                <td>
                  <img
                    src="@/assets/image/home_images/01_Participation_Certificate.png"
                    alt=""
                  />
                  <div>參賽證明</div>
                </td>
                <td>
                  <img
                    src="@/assets/image/home_images/02_Shortlist_Notification.png"
                    alt=""
                  />
                  <div>入圍證明</div>
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td style="font-weight: 600">獎項</td>
                <td class="award-item">
                  <img
                    src="@/assets/image/home_images/03_Gold_Award.png"
                    alt=""
                  />
                  <div>金獎 獎杯<br />現金獎金$2,000<br />證書</div>
                </td>
                <td class="award-item">
                  <img
                    src="@/assets/image/home_images/04_Silver_Award.png"
                    alt=""
                  />
                  <div>銀獎 獎杯<br />現金獎金$1,000<br />證書</div>
                </td>
                <td class="award-item">
                  <img
                    src="@/assets/image/home_images/05_Bronze_Award.png"
                    alt=""
                  />
                  <div>銅獎 獎杯<br />現金獎金$800<br />證書</div>
                </td>
                <td class="award-item">
                  <img
                    src="@/assets/image/home_images/06_Excellence_Award.png"
                    alt=""
                  />
                  <div>優異獎<br />獎牌<br />證書</div>
                </td>
              </tr>
              <tr>
                <td style="font-weight: 600">特色獎項</td>
                <td colspan="4" style="font-weight: 600">
                  最佳造型獎、最佳語音獎、最佳台風獎、優秀指導老師獎、積極參與學校獎、傑出表現學校獎
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table-tips">*獎金發放安排請留意官方公告。</div>
        </div>
      </div>
    </div>
    <!-- 比賽詳情 -->
    <div class="viewBoxContent">
      <div class="box_uls">
        <div class="box_title">
          <img :src="require('@/assets/image/homeTitle/bsxq.png')" alt="" />
        </div>
        <div class="box_centent bxxq">
          <div class="bxxq_title">比賽誦材</div>
          <div class="bxxq_centent">
            <ul>
              <li>參賽學生可在中文路App內不限次數練習參賽誦材。</li>
            </ul>
            <div class="table-tips">
              *參賽學生可自選參賽組別之推薦誦材集內的不同篇章，參與各比賽階段。
            </div>
            <div class="a_view" @click="socai()">點擊下載 比賽誦材</div>

            <table class="materials-table-wrap">
              <tbody>
                <tr>
                  <td style="font-weight: 600">組別</td>
                  <td>
                    <div style="font-weight: 600">誦材類型</div>
                    <div>內容以歌頌中華文化經典為主</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>幼稚園初級組</div>
                    <div>（K1-K2）</div>
                  </td>
                  <td rowspan="2">
                    <div>童詩、古詩</div>
                    <div>（兒歌、繞口令）</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>幼稚園高級組</div>
                    <div>（K3）</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>小學初級組</div>
                    <div>（P1-P2）</div>
                  </td>
                  <td rowspan="2">古诗、童诗、新诗</td>
                </tr>
                <tr>
                  <td>
                    <div>小學中級組</div>
                    <div>（P3-P4）</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>小學高級組</div>
                    <div>（P5-P6）</div>
                  </td>
                  <td rowspan="2">新詩、散文、古文</td>
                </tr>
                <tr>
                  <td>
                    <div>中學組</div>
                    <div>（S1-S6）</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>飛躍組</div>
                    <div>（幼稚園、小學、中學）</div>
                  </td>
                  <td>散文、古詩</td>
                </tr>
                <tr>
                  <td>
                    <div>閃亮組</div>
                    <div>（特殊學校）</div>
                  </td>
                  <td>古詩</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="bxxq_title">比賽章程</div>
          <div class="bxxq_centent">
            <div class="a_view" @click="zhangcheng()">點擊下載 比賽章程</div>
          </div>

          <div class="bxxq_title">評分標準</div>
          <div class="score-box">
            <div class="left-title">1.初賽（AI語音評測）</div>
            <div class="table-tips" style="margin-top: 10px">
              *請注意初賽僅考察讀音準確性。
            </div>
            <table class="table-wrap" style="margin-top: 10px">
              <thead>
                <tr>
                  <th style="width: 26%">評判標準</th>
                  <th>內容説明</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="3">語音（85%）</td>
                  <td style="text-align: left">聲調（25%）</td>
                </tr>
                <tr>
                  <td style="text-align: left">聲母（30%）</td>
                </tr>
                <tr>
                  <td style="text-align: left">韻母（30%）</td>
                </tr>
                <tr>
                  <td>流暢（5%）</td>
                  <td style="text-align: left">流暢度（5%）</td>
                </tr>
                <tr>
                  <td>完整（10%）</td>
                  <td style="text-align: left">
                    完整度（10%）：完整朗讀指定篇目
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="left-title">2. 複賽（錄影）</div>
            <table class="table-wrap">
              <thead>
                <tr>
                  <th style="width: 26%">評判標準</th>
                  <th>內容説明</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="2">語音（30分）</td>
                  <td style="text-align: left">
                    普通話發音（20分）：聲母、韻母、聲調、吐字清晰。每處錯誤扣0.5或1分。
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    節奏韻律（10分）：語速恰當、斷句準確、停連得當。每處錯誤扣0.5或1分。
                  </td>
                </tr>
                <tr>
                  <td rowspan="3">儀態面貌（10分）</td>
                  <td style="text-align: left">服飾大方得體（3分）</td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    舉止從容，大方有感染力（3分）
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">頭尾問好、答謝（4分）</td>
                </tr>
                <tr>
                  <td rowspan="6">誦材處理（60分）</td>
                  <td style="text-align: left">
                    肢體動作（10分）：配以適當的動作和手勢或增加創意部分，完全無動作或肢體語言扣5分。
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    感情處理（15分）：富有感情、有感染力、充分表達誦材的情感、抑揚頓挫、渲染氣氛。
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    表現力（15分）：聲音洪亮、眼神、表情準確自然、活潑生動。
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    內容把握（10分）：誦材基調把握到位、傳遞正確主旨。
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    誦材完成度（10分）：表演自然流暢，文章熟悉，全文背誦。
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="table-tips" style="margin-top: 10px">
              *最終評分解釋權為比賽評審團所屬。
            </div>
            <div class="left-title">3.決賽（現場）</div>
            <table class="table-wrap">
              <thead>
                <tr>
                  <th style="width: 26%">評判標準</th>
                  <th>內容説明</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="2">語音（30分）</td>
                  <td style="text-align: left">
                    普通話發音（20分）：<br />聲母、韻母、聲調、吐字清晰。每處錯誤扣0.5或1分。
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    節奏韻律（10分）：<br />語速恰當、斷句準確、停連得當。每處錯誤扣0.5或1分。
                  </td>
                </tr>
                <tr>
                  <td rowspan="2">儀態面貌（10分）</td>
                  <td style="text-align: left">服裝造型乾淨整潔（3分）</td>
                </tr>
                <tr>
                  <td style="text-align: left">舉止從容，得體大方（7分）</td>
                </tr>
                <tr>
                  <td rowspan="6">誦材處理（60分）</td>
                  <td style="text-align: left">
                    肢體動作（10分）：<br />配以適當的動作和手勢或增加創意部分，完全無動作或肢體語言扣5分。
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    感情處理（15分）：<br />富有感情、有感染力、充分表達誦材的情感、抑揚頓挫、渲染氣氛。
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    表現力（15分）：<br />聲音洪亮、眼神、表情準確自然、活潑生動。
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    內容把握（10分）：<br />誦材基調把握到位、傳遞正確主旨。
                  </td>
                </tr>
                <tr>
                  <td style="text-align: left">
                    誦材完成度（10分）：<br />表演自然流暢，文章熟悉，全文背誦。
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="table-tips" style="margin-top: 0px">
              *最終評分解釋權為比賽評審團所屬。
            </div>
            <div class="table-tips">
              *主辦方保留對比賽流程安排及比賽相關章程的最終解釋權。如有任何爭議，主辦方保留一切最終決定權。
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 複賽指引 -->
    <div class="generateHeats">
      <!-- 复赛资料视频上传-->
      <van-popup
        style="margin-top: 30px"
        v-model="datumZZC"
        :close-on-click-overlay="false"
        :closeable="true"
        :round="true"
        :lock-scroll="false"
      >
        <div class="datumBox">
          <div class="titleH1">
            <div class="left_icon">
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div class="title">上載參賽影片</div>
            <div class="right_icon">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div class="stepBox">
            <div class="stepUls">
              <div
                class="xian"
                :class="stepActive >= 1 ? 'active2' : 'active'"
              ></div>
              <div
                class="xian"
                :class="stepActive >= 2 ? 'active2' : 'active'"
              ></div>
            </div>

            <ul>
              <li
                v-if="chooseFrom == 0"
                v-for="(item, index) in 3"
                :class="stepActive >= index ? 'active' : ''"
                :key="index"
              ></li>
              <li
                v-if="chooseFrom == 1"
                v-for="(item, index) in 2"
                :class="stepActive >= index ? 'active' : ''"
                :key="index"
              ></li>
            </ul>
          </div>
          <div class="stepText">
            <div :class="stepActive >= 0 ? 'active' : ''">登錄</div>
            <div
              v-if="chooseFrom == 0"
              :class="stepActive >= 1 ? 'active' : ''"
            >
              完善資料
            </div>
            <div :class="stepActive >= 2 ? 'active' : ''">上載影片</div>
          </div>
          <div class="datumCentent" v-if="stepActive == 0">
            <div class="tab">
              <div class="prompt" style="margin-bottom: 15px; cursor: pointer">
                <div
                  :class="chooseFrom == 0 ? 'highlight' : ''"
                  @click="datumYZ(0)"
                >
                  個人報名
                </div>
                <div
                  :class="chooseFrom == 1 ? 'highlight' : ''"
                  @click="datumYZ(1)"
                >
                  學校報名
                </div>
              </div>
              <template v-if="chooseFrom == 0">
                <div class="row-input">
                  <div class="input-name">參賽電話</div>
                  <div class="promptInput2">
                    <div class="lis">
                      <div class="lisLife">
                        <CountryCodeSelector
                          :searchbar="false"
                          :countryCode.sync="prefix"
                          style="width: 100px; margin-right: 15px"
                        ></CountryCodeSelector>
                      </div>
                      <div class="lisRight">
                        <input
                          type="text"
                          placeholder="請輸入參賽電話號碼"
                          value=""
                          v-model.trim="from2.phone"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row-input">
                  <div class="input-name">參賽姓名</div>
                  <div class="promptInput">
                    <input
                      placeholder="請輸入參賽者姓名"
                      v-model="from2.name"
                    />
                  </div></div
              ></template>
              <template v-if="chooseFrom == 1">
                <div class="row-input">
                  <div class="input-name">學校編號</div>
                  <div class="promptInput">
                    <input
                      placeholder="請輸入學校編號"
                      v-model.trim="from2.schoolCode"
                    />
                  </div>
                </div>
                <div class="row-input">
                  <div class="input-name">登入編號</div>
                  <div class="promptInput">
                    <input
                      placeholder="請輸入登入編號"
                      v-model.trim="from2.studentCode"
                    />
                  </div>
                </div>
                <div class="row-input">
                  <div class="input-name">參賽姓名</div>
                  <div class="promptInput">
                    <input
                      placeholder="請輸入參賽者姓名"
                      v-model="from2.name"
                    />
                  </div>
                </div>
                <!-- <div class="row-input">
                  <div class="input-name">學生密碼</div>
                  <div class="promptInput">
                    <input
                      placeholder="請輸入學生密碼"
                      v-model.trim="from2.password"
                    />
                  </div>
                </div> -->
              </template>
            </div>
            <div class="tabTis_1">
              提交遇到問題？點擊右側按鈕聯系我們
              <a href="http://wa.me/85291496563" target="_blank" @click="lianxi"
                ><img src="@/assets/image/fusai/whatsapp.png"
              /></a>
            </div>
            <div class="view_guide" @click="generateHeatsZZC = true">
              查看複賽指引
            </div>
            <div
              class="but"
              style="cursor: pointer"
              @click="datumActiveBut ? datumBut(0) : ''"
            >
              下一步
            </div>
          </div>

          <div class="datumCentent" v-if="stepActive == 1">
            <div class="tab">
              <div class="prompt" v-show="schollName == null">就讀學校</div>
              <div
                class="promptInput"
                style="width: 100%; margin-bottom: 15px"
                v-show="schollName == null"
              >
                <input
                  placeholder="請輸入就讀學校"
                  v-model="from2.school_name"
                />
              </div>
              <div class="prompt">
                證件上傳
                <span>&nbsp;帶照片學生證/身份證明</span>
              </div>
              <div class="promptInput3">
                <uploaderCent
                  @uploaderChange="uploaderImageChange"
                  accept="image/*"
                  uploadText="點擊上傳"
                  logoaAtive="0"
                ></uploaderCent>
              </div>
            </div>

            <div class="tabTis">
              提交遇到問題？點擊右側按鈕聯系我們
              <a href="http://wa.me/85291496563" target="_blank" @click="lianxi"
                ><img src="@/assets/image/fusai/whatsapp.png"
              /></a>
            </div>
            <div class="but" style="cursor: pointer" @click="datumBut(1)">
              下一步
            </div>
          </div>

          <div class="datumCentent" v-if="stepActive == 2">
            <div class="tab">
              <div class="promptInput3">
                <uploaderCent
                  @uploaderChange="uploaderVideoChange"
                  accept="video/*"
                  uploadText="點擊上載影片"
                  v-if="wonderful == false"
                  logoaAtive="1"
                ></uploaderCent>
                <!-- 上傳影片成功后顯示預覽按鈕 -->
                <div class="videoYulan" v-if="videoYL">
                  <div
                    class="guanbu"
                    style="cursor: pointer"
                    @click="videoYLBut"
                  >
                    X
                  </div>
                  <video controls :autoplay="true" :src="videoUrl"></video>
                </div>
                <div
                  class="videoYulan2"
                  style="cursor: pointer"
                  v-if="from2.video != null && wonderful == false"
                  @click="videoYLBut"
                >
                  <span style="color: #000000 !important; margin-right: 10px"
                    >影片已成功上載</span
                  >點擊預覽視頻
                </div>
                <!-- 點擊預覽視頻  @click="videoYLBut"-->
                <!-- <div class="viewVideo" v-if="from2.video && wonderful == false">
                <div>影片已成功上載</div>
                <div
                  class="videoYulan2"
                  @click="videoYLBut"
                >
                  點擊預覽視頻
                </div>
              </div>
              <div v-if="from2.video && wonderful == false" class="reselect">重新选择</div> -->

                <!-- 提交成功 -->
                <div class="wonderful" v-if="wonderful == true">
                  <img src="@/assets/image/fusai/ludui.png" />
                  恭喜你，成功上載影片，請耐心等待評審結果
                </div>
              </div>
            </div>
            <div class="tabTis" v-if="wonderful == false">
              提交遇到問題？點擊右側按鈕聯系我們
              <a href="http://wa.me/85291496563" target="_blank" @click="lianxi"
                ><img src="@/assets/image/fusai/whatsapp.png"
              /></a>
            </div>
            <div
              class="but"
              style="cursor: pointer"
              v-if="wonderful == false"
              @click="datumActiveBut ? submit() : ''"
            >
              提交
            </div>
            <!-- <div class="but2" style="cursor: pointer;" @click="getBack()">返回上一步</div> -->
            <div
              class="but"
              style="cursor: pointer"
              v-if="wonderful == true"
              @click="wonderfulBut"
            >
              我知道了
            </div>
          </div>

          <!-- 未入圍/成功入園 -->
          <van-popup v-model="newShortZZC" :round="true" :lock-scroll="false">
            <div class="newShortBox">
              <div class="list" v-if="newShortActive == 2">
                <div class="ulst">
                  <ul>
                    <li>姓名</li>
                    <li>組別</li>
                    <li>分數</li>
                  </ul>
                  <ul>
                    <li>
                      {{
                        userObj.studentName == null ? "" : userObj.studentName
                      }}
                    </li>
                    <li>
                      {{
                        userObj.competitionGroup == null
                          ? ""
                          : userObj.competitionGroup
                      }}
                    </li>
                    <li>{{ userObj.score == null ? "" : userObj.score }}</li>
                  </ul>
                </div>
                <div class="lis lisText">
                  很遺憾，您的成績未能入圍複賽，非常感謝您的參與
                </div>
              </div>
            </div>
          </van-popup>
        </div>
      </van-popup>

      <van-dialog
        v-model="showGuide"
        :show-close-button="false"
        :close-on-click-overlay="true"
        width="80%"
        z-index="99999"
        confirm-button-text="關 閉"
        @close="closeDialog"
      >
        <div class="guide-container" v-if="showType == 'img'">
          <van-image width="100%" :src="guideUrl" fit="contain" />
        </div>
        <div class="guide-container" v-if="showType == 'video'">
          <video
            width="100%"
            height="99%"
            controls
            :autoplay="true"
            :src="guideUrl"
          ></video>
        </div>
      </van-dialog>

      <van-popup v-model="generateHeatsZZC" :round="true" :lock-scroll="false">
        <div class="generateHeatsBox">
          <div class="uls">
            <div class="titleH1">
              <div class="left_icon">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="title">複賽指引</div>
              <div class="right_icon">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>

            <div class="textCentent">
              <div class="color1 font_size1" style="margin-bottom: 6px">
                請按照下方參賽影片要求進行錄製，否則將影響評分。如提交影片遇到困難，請于活動頁左下方WhatsApp進行留言，主辦機構中文路ChineseRd將會提供支援。
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                *凡是參賽的選手，等同於同意主辦機構中文路ChineseRd將此次參賽影片使用於全媒體渠道展示宣傳。
                <br />
                *為免遇上網絡擠塞，請預留好上載複賽影片的時間。
                <br />
                *所有參賽影片錄製必須為參賽者本人，如審核發現非參賽者本人錄製之情況，將予以失格公示。
                <br />
              </div>
              <div class="titleRed">【參賽影片要求】</div>
              <div class="color1 font_size1" style="margin-bottom: 6px">
                1. 參賽者應依照以下次序錄製影片：
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                ①
                用普通話進行自我介紹，包含姓名、組別、來自哪一間幼稚園/小學/中學等。
                <br />
                ②
                用普通話讀出比賽誦材之標題及作者（如若誦材未標明作者，可以只讀誦材標題）。
                <br />
                ③ 用普通話朗誦誦材內容一次。
                <br />
                ④ <span class="color1" style="font-weight: 600;">參賽者必須背誦誦材</span>，違者將只獲評語，沒有評級，亦不獲發獎狀。
                <br />
                ⑤ 如參賽者於影片中重複演繹同一作品，只有首次演繹獲得評審。
                <br />
                ⑥ 請使用<span class="color1" style="font-weight: 600;">豎屏</span>拍攝。
                <br />
                ⑦ 影片時長要求：閃亮組、飛躍組、幼稚園組、小學初級、中級組：3 分鐘以內；小學高級組、中學組：6 分鐘以內。
                <br />
              </div>
              <div class="color1 font_size1" style="margin-bottom: 6px">
                2. 參賽者必須根據以下指引，否則將影響評分：
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                ① 參賽者錄製參賽影片時請注意着裝得體。
                <br />
                ② 整段影片須清楚顯示參賽者之全身、樣貌及動作。
                <br />
                ③
                拍攝影片時，應保持拍攝鏡頭穩定及定鏡拍攝，不應移動、推進及拉近鏡頭。
                <br />
                ④
                為確保影片聲畫同步、畫面與聲音清晰和流暢，影⽚解像度為720p(1280x720)或以上。
                <br />
                ⑤
                在室內以簡單背景和寧靜的環境下拍攝，並確保光度充足，避免背光、使用虛擬或投射背景。
                <br />
                ⑥ 參賽者不應使用任何款式耳機作為收音用途。
                <br />
                ⑦ 拍攝影片時請勿使用擴音器。
                <br />
              </div>

              <div class="color1 font_size1" style="margin-bottom: 6px">
                3. 參賽者必須跟隨以下指引，否則將被取消資格：
              </div>
              <div class="color2 font_size2" style="margin-bottom: 20px">
                ① 影片必須為一鏡到底的拍攝原片，拍攝途中不可暫停攝影機。
                <br />
                ②
                影片中不可加入特別效果，例如濾鏡、過渡、調色、調光、字幕等，亦不得進行任何混音、剪接及後期製作。
                <br />
                ③ 影片必須是現場收音及錄像，不可配音。
                <br />
              </div>
              <div class="titleRed">【影片上傳要求】</div>
              <div class="font_size2" style="margin-bottom: 20px">
                <span class="color2"
                  >① 參賽者須通過 <span class="color1" style="font-weight: 600;">官方活動網站：</span>https://speech.chineserd.com 或 <span class="color1" style="font-weight: 600;">中文路App：</span>ChineseRd Plus 上傳參賽影片。</span
                >
                <br />
                <span class="color1"
                  >② 參賽者有責任確保以下資料正確，包括：</span
                >
                <br />
                <span class="color2">
                  網頁中的各項資料正確。如發現資料有誤，請于活動頁左下方WhatsApp進行留言，主辦機構中文路ChineseRd將會提供支援，根據指引於限期內重新提交。
                </span>
                <br />
                <span class="color2"
                  >所提交的影片須與參賽者及其比賽項目相符。如記錄不符，評審團有權不評審相關影片。</span
                >
                <br />
                <span class="color1"
                  >③ 如重複提交，將以最後一次符合提交條件的記錄為準。</span
                >
                <br />
                <span class="color1"
                  >④
                  如評審期內因任何原因，影片未能播放，不會就此作個別通知，參賽者將不獲評分（評級）或獎狀。</span
                >
                <br />
              </div>
              <div class="but" @click="handleUploadVideo()">
                <img :src="require('@/assets/image/fusai/yunshang.png')" />
                點擊上載視頻
              </div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/pc_header";
import publics from "@/mixin/public_mixin";
import home from "@/mixin/home_mixin";
import uploaderCent from "@/components/uploaderBox/index.vue";
import CountryCodeSelector from "@/components/CountryCodeSelector";
import { speecheduUrl } from "@/utils/link";
import { h } from "vue";

export default {
  name: "views",
  data() {
    return {
      generateHeatsZZC: false,
      ermUrl: sessionStorage.getItem("whatAppEwm"),
      datumZZC: false, // 上传视频弹窗控制 
      stepActive: 0, //控制流程  很重要这玩意勿搞错  参数0 1 2  表示三步骤
      datumActiveBut: true, //防止連續點擊
      wonderful: false, //成功
      videoYL: false, //預覽
      chooseFrom: 0, //驗證
      from2: {
        name: null, //名字
        school_name: null, //学校
        email: null, //邮箱
        phone: null, //手机
        certificate: null, //证件
        video: null, //视频
      },
      schollName: null, //控制学校是否显示
      newShortZZC: false, //入圍 彈窗
      newShortActive: 1, //1是成功  2是失敗
      choose: 0, //查詢的下標
      from: {
        school_name: null,
        email: null,
        phone: null,
      },
      finalistsBut: true, //防止連續點擊
      userObj: {
        competitionGroup: null, //組別
        score: null, //分數
        studentName: null, //名字
      },
      prefix: "852",
      showGuide: false,
      showType: "",
      guideUrl: "",
    };
  },
  computed: {},
  components: {
    headers,
    uploaderCent,
    CountryCodeSelector,
  },
  mixins: [publics, home],
  watch: {},
  created() {},
  mounted() {
    if (this.$route.query.uploadVideo) {
      this.datumZZC = true;
      this.$router.replace({ query: { uploadVideo: false } });
    }
  },
  methods: {
    goToSchoolInfo() {
      let url = "https://edu.chineserd.com/schoolInformation";
      if (window.location.host.indexOf("chineserd") == -1) {
        url = "https://edutest.chineserd.com/schoolInformation";
      }
      window.open(url, "_blank");
    },
    homeToLogin() {
      let url = "https://edu.chineserd.com/";
      if (window.location.host.indexOf("chineserd") == -1) {
        url = "https://edutest.chineserd.com/";
      }
      window.open(url, "_blank");
    },
    closeDialog() {
      const videoElement = document.querySelector(".guide-container video");
      // 暂停视频播放
      videoElement.pause();
    },
    handleShowGuide(type, url) {
      this.showGuide = true;
      this.showType = type;
      this.guideUrl = url;
      this.$nextTick(() => {
        // 动态浏览器视口高度
        const viewportHeight = window.innerHeight;
        const browserInterfaceHeight = window.outerHeight - window.innerHeight;
        const browserWindowHeight = viewportHeight - browserInterfaceHeight;
        const imageContainer = document.querySelector(".guide-container");
        imageContainer.style.height = `${browserWindowHeight}px`;
      });
    },
    handleUploadVideo() {
      this.datumZZC = true;
      this.generateHeatsZZC = false;
    },
    whatapp() {
      this.home_mdevInit();
      window.open(this.whatUrl, "_blank");
    },
    aheftBut(e) {
      // this.$dialog
      //   .alert({
      //     title: '提示',
      //     message: '報名未開始',
      //     confirmButtonText: '確認'
      //   })
      //   .then(() => {
      //     // on close
      //   })
      if (this.currentCompetition === "1") {
        this.$router.push("/signup");
      } else {
        window.open(speecheduUrl, "_blank");
      }
    },
    zhangcheng() {
      window.open(this.rulesList[0].url, "_blank");
      // this.$toast.loading({
      // 	message: '獲取地址中...',
      // 	forbidClick: true,
      // 	duration: 0
      // });

      // let url = 'https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2023-07/fe62588d996ef0818389f65f4192086c.pdf';
      // this.$axios({
      //   url: url,
      //   method: 'get',
      //   responseType: 'blob',
      // })
      // .then(response => {
      //   this.$toast.clear();
      //   this.$toast.success('開始下載');
      //   // 将文件流转化为 Blob 对象，并创建 a 标签进行下载
      //   const blob = new Blob([response.data], { type: 'application/pdf' });
      //   const downloadElement = document.createElement('a');
      //   const href = window.URL.createObjectURL(blob); // 创建下载链接
      //   downloadElement.href = href;
      //   downloadElement.download = 'zhangcheng.pdf'; // 文件名
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click(); // 下载
      //   document.body.removeChild(downloadElement); // 下载完成后移除元素
      //   window.URL.revokeObjectURL(href); // 释放占用的内存空间
      // }).catch(error => {
      //   this.$toast.clear();
      //   console.error(error); // 处理异常情况
      // });
    },
    socai() {
      this.$router.push("/material");
    },
    stageBut(e) {
      this.competitionTimeLine.forEach((item, index) => {
        // console.log(item, index);
        if (index == e) {
          item.select = true;
        } else {
          item.select = false;
        }
      });
    },
    datumYZ(e) {
      this.chooseFrom = e;
    },
    lianxi() {
      // 联系我们
      // window.location.href = 'http://wa.me/85291496563'
      window.open("http://wa.me/85291496563");
    },
    // 點擊上傳下一步
    datumBut(e) {
      switch (e) {
        case 0:
          // 下一步 驗證信息
          this.getUser();
          break;
        case 1:
          // this.$toast.clear()
          // 判断学校跟证件
          if (this.from2.school_name == null || this.from2.school_name == "") {
            this.$toast("请输入就讀學校 !");
            return;
          }

          if (this.from2.certificate == null || this.from2.certificate == "") {
            this.$toast("请上傳證件 !");
            return;
          }
          this.stepActive = 2;
          break;
        case 2:
          // 提交啦
          break;
        case 3:
      }
    },
    // 驗證信息
    getUser() {
      let params = {
        competitionType: 8,
      };
      if (this.chooseFrom == 0) {
        params = {
          studentName: this.from2.name,
          prefix: this.prefix,
          phone: this.from2.phone,
          email: null,
        };
      } else if (this.chooseFrom == 1) {
        const { schoolCode, studentCode, password, name } = this.from2;
        // 判断三个参数不能为空
        if (schoolCode == "" || schoolCode == null) {
          this.$toast("請輸入學校編號 !");
          return;
        }
        if (studentCode == "" || studentCode == null) {
          this.$toast("請輸入登入編號 !");
          return;
        }
        if (name == "" || name == null) {
          this.$toast("請輸入參賽者姓名 !");
          return;
        }
        // if (password == "" || password == null) {
        //   this.$toast("請輸入學生密碼 !");
        //   return;
        // }
        params = {
          schoolCode,
          studentCode,
          password,
          studentName: name,
          competitionType:8,
        };
      }

      if (this.chooseFrom == 0) {
        // 手機
        if (params.phone == "" || params.phone == null) {
          this.$toast("手機號格式有誤 !");
          return;
        }

        if (!this.validator_phone(params.phone)) {
          this.$toast("手機號格式有誤 !");
          return;
        }
        if (params.studentName == "" || params.studentName == null) {
          this.$toast("請輸入您的姓名 !");
          return;
        }
        // } else if (this.chooseFrom == 1) {
        // 郵箱
        // if (!this.validator_email(params.email)) {
        //   this.$toast('電郵格式有誤 !')
        //   return
        // }
      }
      // console.log('上传:', params);
      this.datumActiveBut = false;
      this.$toast.loading({
        message: '加載中...',
        forbidClick: true,
        zIndex: 999999
      });
      this.$axios
        .post(this.$api.getPersonInfo, params)
        .then((response) => {
          this.datumActiveBut = true;
          this.$toast.clear();
          // console.log(response);
          const { data, code, msg } = response.data;
          if (code == 500) {
            this.$toast.fail({
              message: msg,
              zIndex: 999999
            });
            return;
          }
          const { competitionGroup, score, studentName, shortlisted, school } =
            data;
          if (code == 0) {
            this.userObj.competitionGroup = competitionGroup; //組別
            this.userObj.score = score; //分數
            this.userObj.studentName = studentName; //名字
            if (shortlisted) {
              this.from2.school_name = school;
              this.schollName = school == "" ? null : school;
              // 成功
              if (this.chooseFrom == 0) {
                this.stepActive = 1;
              } else {
                this.stepActive = 2;
              }
            } else {
              // 失敗
              // this.datumZZC = false; //复赛资料上传弹窗
              this.stepActive = 0; //控制流程  很重要这玩意勿搞错  参数0 1 2  表示三步骤
              this.newShortZZC = true; //入圍 彈窗
              this.newShortActive = 2; //1是成功  2是失敗
            }
          }
        })
        .catch((error) => {
          this.$toast.clear();
          this.datumActiveBut = true;
          //请求失败
          this.$toast.fail({
            message: "error",
            zIndex: 999999
          });
          // console.log(error);
        });
    },
    validator_email(val) {
      const email = val.trim();
      return /^[A-Za-z0-9]+([_\-\.][A-Za-z0-9]+)*@([A-Za-z0-9\-\_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    validator_phone(val) {
      const phone = val.trim();
      return /^[0-9]*$/.test(phone);
    },
    // 視頻
    uploaderVideoChange(e) {
      // console.log('视频', e);
      this.from2.video = e.vaidoUrl;
      this.videoUrl = e.vaidoUrl;
      this.$toast.clear();
    },
    // 圖像
    uploaderImageChange(e) {
      // console.log('圖像',e);
      this.from2.certificate = e.vaidoUrl;
      this.$toast.clear();
    },
    // 視頻預覽
    videoYLBut() {
      this.videoYL = !this.videoYL;
    },
    //返回上一步
    // getBack() {
    // 	this.stepActive--;
    //   this.from2.video = null
    //   this.videoUrl = null
    // },
    // 提交
    submit() {
      const {
        phone,
        name,
        video,
        email,
        certificate,
        school_name,
        schoolCode,
        studentCode,
        password,
      } = this.from2;
      let params = {
        // videoUrl: 'https://materialv3-1256597606.cos.ap-hongkong.myqc…/dev/2023-09/eb816d9e21e9f18fccea6c461ba2c3dc.mp4', //学生上传的视频内容
        videoUrl: video, //学生上传的视频内容
        // email, //學生電郵
        personalID: certificate,
        currentSchool: school_name,
        competitionType: 8,
      };
      if (this.chooseFrom == 1) {
        // 学校报名
        params.schoolCode = schoolCode;
        params.studentCode = studentCode;
        params.password = password;
      } else {
        // 个人报名
        params.phone = phone;
        params.studentName = name;
      }

      if (params.videoUrl == null || params.videoUrl == "") {
        this.$toast("請上傳參賽作品 !");
        return;
      }

      this.datumActiveBut = false;
      this.$toast.loading({
        message: "正在提交中...",
        duration: 0,
        forbidClick: true,
      });
      this.$axios
        .post(this.$api.update, params)
        .then((response) => {
          this.datumActiveBut = true;
          if (response.data.code == 500) {
            this.$toast.fail(response.data.msg);
          }
          if (response.data.code == 0) {
            this.$toast.clear();
            this.wonderful = true;
          }
        })
        .catch((error) => {
          this.datumActiveBut = true;
          //请求失败
          this.$toast.fail("error");
          console.log(error);
        });
    },
    // 上傳成功  相當於初始化
    wonderfulBut() {
      this.wonderful = false;
      this.datumZZC = false;
      this.stepActive = 0;
      let from = {
        name: null,
        school_name: null,
        email: null,
        phone: null,
        certificate: null,
        video: null,
      };
      this.from2 = from;
    },
  },
};
</script>

<style lang="scss" scoped>
.awards-box {
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 12px;
  padding: 24px;
  box-sizing: border-box;
}

.table-wrap {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #fa772f;
  font-size: 16px;
  line-height: 22px;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #666;

  th {
    border: 1px solid #fa772f;
    padding: 10px;
    font-weight: 600;
  }
  td {
    border: 1px solid #fa772f;
    padding: 10px;
    vertical-align: middle;
  }

  span {
    font-weight: 600;
  }
}

.table-tips {
  margin-top: 20px;
  font-size: 16px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #e80202;
  text-align: left;
  line-height: 22px;
}

.score-box {
  .left-title {
    margin: 25px 0 15px 0;
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    color: #fa772f;
  }
  .table-wrap {
    margin-bottom: 15px;
  }
}

.views {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  background: #ff782f;
  padding-bottom: 40px;
  .posters {
    width: 100%;
    display: flex;
    position: relative;

    img {
      width: 100%;
    }

    .posters_ewm {
      position: absolute;
      // width: 1024px;
      right: 20px;
      bottom: 20px;
      margin: auto;
      display: flex;
      align-items: flex-start;
      justify-content: right;

      .ewm {
        width: 141px;
        min-height: 184px;
        background: rgba(255, 255, 255, 0.63);
        border-radius: 16px 16px 16px 16px;
        padding: 6px;
        box-sizing: border-box;
        cursor: pointer;

        .ewm2 {
          width: 100%;
          height: 100%;
          background: #fdcf1d;
          border-radius: 12px 12px 12px 12px;
          box-sizing: border-box;
          padding-top: 4px;
          .ewm3 {
            margin: 0 auto;
            width: 122px;
            height: 122px;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            margin-bottom: 6px;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .ewm3_value {
            width: 100%;
            height: 40px;
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            background: url("~@/assets/image/icon/ewmbut.png") no-repeat;
            background-size: 100% 100%;
            box-shadow: inset 0px 1px 4px 0px rgba(234, 138, 7, 0.48),
              inset 0px -5px 3px 0px rgba(255, 227, 129, 0.57);
            vertical-align: middle; /* 将文本和图片垂直居中对齐 */

            img {
              width: 20px;
              height: 20px;
              margin-right: 4px;
              vertical-align: middle; /* 将图片和文本垂直居中对齐 */
            }
          }
        }
      }
    }
  }

  .organizers {
    max-width: 1240px;
    margin: auto;
    margin-bottom: 54px;
    margin-top: 30px;
    .box_uls {
      width: 964px;
      min-height: 100px;
      margin: auto;
      box-sizing: border-box;
      border-image-source: url("~@/assets/image/hodgepodge/pcbeij.png");
      border-image-slice: 84 10 10 10;
      border-image-width: 67px 9px 9px 9px;
      border-width: 9px;
      padding: 0 10px 10px 10px;
      box-sizing: border-box;

      .box_title_ {
        width: 100%;
        height: 40px;
        box-sizing: border-box;
        margin: auto;
        position: relative;

        img {
          // width: 100%;
          height: 118.8px;
          margin-top: -4.6%;
          // object-fit: none;
        }
      }
      .box_centent {
        position: relative;
        width: 100%;
        background: #ffffff;
        border-radius: 12px;
      }
      .xiaoIconBox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 8px;
        padding: 24px 50px 0px 50px;
        box-sizing: border-box;
        .title_left {
          width: 100px;
          font-size: 14px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 24px;
          text-align: left;
        }
        .xiaoIconList {
          flex: 1;
          max-width: 250px;
          margin: 0 8px;
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.03);
          overflow: hidden;

          img {
            display: block;
            width: 100%;
            height: auto;
          }
        }
      }
      .xiaoIconTextBox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 50px 27px 50px;
        box-sizing: border-box;

        .xiaoIconTextItem {
          flex: 1;
          max-width: 250px;
          margin: 0 8px;
          text-align: center;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
        }
      }
      .box_zhuban {
        background: #ffffff;
        border-radius: 12px;
        position: relative;
      }
      .zhuban {
        box-sizing: border-box;
        position: relative;
        width: 100%;
        padding: 0 100px 24px 100px;
        box-sizing: border-box;

        .posters_text {
          width: 100%;
          ul {
            width: 100%;

            li {
              width: 100%;
              margin-bottom: 16px;
              display: flex;

              .posters_text_left {
                width: 100px;
                font-size: 14px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 24px;
              }

              .posters_text_right {
                width: calc(100% - 80px);
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 24px;
                text-align: left;
                margin-left: 20px;
              }
            }
          }
        }
      }
    }
  }

  .TimeAxis {
    max-width: 1240px;
    // height: 800px;
    margin: 90px auto 150px auto;

    ul {
      width: 100%;

      .time_xian {
        width: 100%;
        background: linear-gradient(
          270deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 22%,
          #ffffff 80%,
          rgba(255, 255, 255, 0) 100%
        );
        display: flex;
        justify-content: space-evenly;

        li {
          width: 167px;
          display: flex;
          align-items: center;

          .xian {
            width: 100%;
            height: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
              width: 16px;
              height: 16px;
              background: #ffffff;
              border: 2px solid #ffffff;
              border-radius: 50px;
              cursor: pointer;
            }

            .span_t {
              width: 20px !important;
              height: 20px !important;
              background: #ffe600 !important;
            }

            .select {
              width: auto !important;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0 10px;
              font-size: 14px;
              text-align: center;
              box-sizing: border-box;
              background: #f78040;
              border-radius: 50px;
              border: 1px solid #fff;
              color: #fff;
            }
          }
        }
      }

      .time_xian_top {
        width: 100%;
        height: 86px;
        display: flex;
        justify-content: space-evenly;
        margin-bottom: 17px;

        li {
          width: 167px;
          display: flex;
          align-items: center;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          cursor: pointer;
        }

        .select {
          // border-image-source: url("~@/assets/image/icon/qipao.png");
          // border-image-slice: 84 10 10 10;
          // border-image-width: 33px 9px 0px 10px;
          // border-width: 9px;
          // padding: 7px 17px 14px 17px;
          // box-sizing: border-box;
          // font-size: 16px;
          // font-family: PingFang SC-Semibold, PingFang SC;
          // font-weight: 600;
          // color: #903300;
          // line-height: 16px;
        }

        .cshhSelect {
          font-size: 16px;
          font-family: PingFang SC-Semibold, PingFang SC;
          // font-weight: 600;
          color: #ffffff;
          line-height: 19px;
        }

        img {
          height: 100%;
          object-fit: contain;
        }
      }

      .time_xian_timeBox {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        margin-top: 17px;

        li {
          width: 167px;
          display: flex;
          align-items: center;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 22px;
          cursor: pointer;
        }
      }

      .time_xian_fuchuang {
        width: 100%;
        display: flex;
        justify-content: space-evenly;

        li {
          width: 167px;
          min-height: 136px;

          .list {
            width: 343px;
            min-height: 136px;
            box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.05);
            padding: 12px;
            box-sizing: border-box;
            margin-top: 38px;
            border-radius: 16px;
            background: #ffffff;
            position: relative;

            h1 {
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #f97226;
              line-height: 20px;
              text-align: center;
              margin-bottom: 4px;
              text-align: left;
            }

            .p_xian {
              width: 100%;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 22px;
              text-align: left;
            }

            .butom {
              width: 100%;
              display: flex;
              justify-content: right;
              position: absolute;
              bottom: 0;
              padding: 0 24px 12px 0;
              box-sizing: border-box;

              .buttomBut {
                padding: 10px 12px;
                box-sizing: border-box;
                border-radius: 16px;
                font-size: 12px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ffffff;
                line-height: 14px;
                background: url("~@/assets/image/hodgepodge/buttom.png")
                  no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
              }
            }
          }
        }

        li:last-child {
          .list {
            float: right;
          }
        }
      }
    }
  }

  .viewBoxContent {
    max-width: 1240px;
    margin: auto;
    margin-top: 104px;

    .box_uls {
      width: 964px;
      min-height: 314px;
      margin: auto;
      box-sizing: border-box;
      border-image-source: url("~@/assets/image/hodgepodge/pcbeij.png");
      border-image-slice: 84 10 10 10;
      border-image-width: 67px 9px 9px 9px;
      border-width: 9px;
      padding: 0 10px 10px 10px;
      box-sizing: border-box;
      .box_title {
        width: 100%;
        height: 25px;
        box-sizing: border-box;
        margin: auto;
        position: relative;

        img {
          // width: 100%;
          height: 118.8px;
          margin-top: -6.1%;
          // object-fit: none;
        }
      }
      .box_centent {
        position: relative;
        width: 100%;
        background: #ffffff;
        border-radius: 12px;
        padding: 24px 130px;
        box-sizing: border-box;
      }

      .cszg {
        width: 100%;
        padding: 50px 130px !important;
      }

      .cszg2 {
        .cszg2_list {
          // font-size: 15px;
          // font-family: PingFang SC-Semibold, PingFang SC;
          // font-weight: 600;
          // // color: #f97226;
          // line-height: 22px;
          // text-align: left;
          margin-bottom: 24px;
          ul {
            width: 100%;
            padding-left: 0.48rem;
            box-sizing: border-box;
            margin-top: 10px;
            li {
              width: 100%;
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              color: #666666;
              line-height: 28px;
              text-align: left;
              // list-style: disc;
            }
          }
        }

        .cszg2_uls {
          width: 100%;
          box-sizing: border-box;
          margin-bottom: 24px;
        }

        .cszg2_remarks {
          width: 100%;
          font-size: 15px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 22px;
        }
      }

      .bxxq {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .bxxq_title {
          min-width: 160px;
          height: 36px;
          background: #ff9003;
          box-shadow: 0px 0px 7px 0px rgba(249, 118, 47, 0.3);
          border-radius: 31px 31px 31px 31px;
          border: 2px solid #ffffff;
          padding: 7px 48px;
          box-sizing: border-box;
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          margin: auto;
          margin-bottom: 16px;
        }

        .bxxq_centent {
          width: 100%;
          margin-bottom: 50px;

          p {
            margin: 20px 0;
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            color: #666666;
            text-align: left;
          }

          ol {
            width: 100%;
            padding-left: 0.48rem;
            box-sizing: border-box;
            list-style: decimal;

            li {
              width: 100%;
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              color: #666666;
              line-height: 28px;
              text-align: left;
              // list-style: disc;
              display: list-item; // 确保使用列表项显示

              span {
                color: #f97226;
                font-weight: 600;
              }

              strong {
                color: #e80202;
                font-weight: 600;
              }
            }
          }

          .a_view {
            margin-top: 25px;
            text-align: center;
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #e80202;
            text-decoration: underline;
            cursor: pointer;
          }
        }

        .bxxq_centent:last-child {
          margin-bottom: 0px;
        }
      }

      .csjx {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .csjx_title {
          min-width: 160px;
          height: 36px;
          background: #ff9003;
          box-shadow: 0px 0px 7px 0px rgba(249, 118, 47, 0.3);
          border-radius: 31px 31px 31px 31px;
          border: 2px solid #ffffff;
          padding: 7px 48px;
          box-sizing: border-box;
          font-size: 16px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          margin: auto;
          margin-bottom: 24px;
        }

        // .csjx_centent:last-child {
        //   margin-bottom: 0px;
        // }

        .csjx_centent {
          width: 100%;
          margin-bottom: 45px;

          .csjx_centent_view1 {
            width: 414px;
            min-height: 141px;
            padding: 16px 24px;
            box-sizing: border-box;
            background: #fff6f1;
            border-radius: 16px;
            border: 2px solid #fed011;
            position: relative;
            margin: auto;
            margin-bottom: 24px;

            h1 {
              width: 100%;
              display: flex;
              font-size: 16px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #f97226;
              line-height: 18px;

              span {
                color: #ff8f03;
                margin-left: 8px;
                font-weight: 500;
                font-size: 14px;
              }
            }

            ul {
              width: 100%;
              margin-top: 20px;
              padding-left: 20px;
              box-sizing: border-box;

              li {
                width: 100%;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 14px;
                text-align: left;
                list-style: disc;
                font-weight: 400;
                margin-bottom: 15px;
              }

              li:last-child {
                margin-bottom: 0px;
              }
            }

            .jinpai {
              width: 90px;
              position: absolute;
              right: -37px;
              bottom: -6px;

              img {
                width: 100%;
              }
            }

            .jiangbei {
              width: 90px;
              position: absolute;
              right: -40px;
              bottom: -6px;

              img {
                width: 100%;
              }
            }
          }

          .csjx_centent_view2 {
            width: 414px;
            background: #fff6f1;
            border-radius: 16px;
            border: 1px solid #fa772f;
            position: relative;
            margin: auto;
            // margin-bottom: 24px;
            display: flex;

            .lists {
              width: 146px;
              height: 98px;
              font-size: 14px;
              font-family: PingFang SC-Semibold, PingFang SC;
              color: #f97226;
              line-height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-right: 1px solid #fa772f;
            }

            .lists2 {
              width: calc(100% - 146px);

              ul {
                width: 100%;
                height: 100%;
                padding: 16px 24px 16px 48px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                align-content: center;

                li {
                  width: 100%;
                  font-size: 14px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #666666;
                  text-align: left;
                  list-style: disc;
                  font-weight: 400;
                  margin-bottom: 16px;
                }

                li:last-child {
                  margin-bottom: 0px;
                }
              }
            }
          }

          .bo_color {
            background: #fffce8 !important;
            border: 2px solid #fed011 !important;
          }

          .bo_color2 {
            background: #f9fcff !important;
            border: 2px solid #d1e1ee !important;
          }
          .bo_color3 {
            background: #fff4ee !important;
            border: 2px solid #fa772f !important;
          }
        }
      }
    }
  }
  .uploadVideo {
    cursor: pointer;
    position: absolute;
    z-index: 99999;
    top: 16px;
    right: 40px;
    width: 136px;
    height: 48px;
    background: url("~@/assets/image/icon/but.png") no-repeat;
    background-size: 100% 100%;
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 15px;
    box-shadow: 0px 4px 9px 0px rgba(244, 86, 5, 0.4);
    border-radius: 80px;
    padding: 15px;
    box-sizing: border-box;
  }

  .datumBox {
    width: 780px;
    // height: 308px;
    padding-top: 45px;
    padding-bottom: 45px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;

    .titleH1 {
      width: 100%;
      font-size: 22px;
      color: #ff5a25;
      font-weight: 600;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;

      .right_icon {
        display: flex;
        align-items: center;
        div:nth-child(3) {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:first-child {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
      }

      .left_icon {
        display: flex;
        align-items: center;
        div:first-child {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(3) {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
      }
    }

    .stepBox {
      width: 55%;
      margin: auto;
      position: relative;

      .stepUls {
        width: 100%;
        height: 30px;
        display: flex;

        .xian {
          width: 50%;
          height: 100%;
          position: relative;
        }

        .active {
          position: relative;
        }

        .active:after {
          content: " ";
          width: 100%;
          height: 2.5px;
          background: #f5f5f5;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }

        .active2:after {
          content: " ";
          width: 100%;
          height: 2.5px;
          background: #ff5a25;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }

      ul {
        width: 100%;
        height: 30px;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        li {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #ff5a25;
          position: relative;

          div {
            position: absolute;
            bottom: -10%;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #cccccc;
          }
        }

        .active {
          width: 19px;
          height: 19px;
          border-radius: 50%;
          background: url("~@/assets/image/fusai/dui.png") no-repeat;
          background-size: 100%;
        }
      }
    }

    .stepText {
      width: 62%;
      margin: auto;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      div {
        font-size: 18px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #cccccc;
      }
      div:nth-child(1) {
        margin-left: 5%;
      }

      div:nth-child(2) {
        margin-left: 13%;
      }

      div:nth-child(3) {
        margin-left: 10%;
      }

      .active {
        color: #de2810 !important;
      }
    }

    .datumCentent {
      width: 70%;
      margin: auto;
      margin-top: 30px;

      .tab {
        width: 100%;
        text-align: left;
        margin-bottom: 13px;

        .prompt {
          height: 26px;
          font-size: 18px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          line-height: 18px;
          // margin-bottom: 12px;
          // padding-left: 13px;
          // box-sizing: border-box;
          display: flex;

          div {
            margin-right: 18px;
            text-align: center;
            line-height: 20px;
            color: #999999;
          }

          .highlight {
            color: #4d4d4d !important;
            position: relative;
          }

          .highlight:after {
            content: " ";
            width: 90%;
            height: 1px;
            background: #4d4d4d;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
          }

          span {
            font-size: 9.8px !important;
            color: #de2810;
            margin-left: 5px;
          }
        }

        .lis {
          width: 100%;
          height: 45px;
          line-height: 45px;
          background: #f5f5f5;
          display: flex;
          justify-content: space-between;
          border-radius: 6px 6px 6px 6px;
          // overflow: hidden;
          position: relative;
          .lisLife {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #4a4a4a;
            box-sizing: border-box;
            width: 18%;
            padding-left: 15px;

            img {
              width: 16px;
              height: 11px;
              margin-right: 5px;
            }
          }

          .lisRight {
            width: 81%;
            height: 100%;
            input {
              width: 100%;
              height: 100%;
              padding-left: 13px;
              box-sizing: border-box;
              border: none;
              background: #f5f5f5;
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
            }
            input::-webkit-input-placeholder {
              color: #999999;
            }
            /* 使用webkit内核的浏览器 */
            input:-moz-placeholder {
              color: #999999;
            }
            /* Firefox版本4-18 */
            input::-moz-placeholder {
              color: #999999;
            }
            /* Firefox版本19+ */
            input:-ms-input-placeholder {
              color: #999999;
            } /* IE浏览器 */
          }
        }
        .row-input {
          display: flex;
          align-items: center;
          font-size: 0px;
          margin-bottom: 15px;
        }
        .input-name {
          width: 20%;
          // height: 30px;
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4d4d4d;
          text-align: right;
          padding-right: 15px;
          box-sizing: border-box;
        }
        .promptInput {
          width: 80%;
          height: 50px;
          box-sizing: border-box;
          background: #f5f5f5;
          border-radius: 5px;
          // margin-bottom: 15px;

          input {
            width: 100%;
            height: 100%;
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            background: #f5f5f5;
            border-radius: 5px;
            border: none;
            padding-left: 13px;
            box-sizing: border-box;
          }

          input::-webkit-input-placeholder {
            color: #999999;
          }
          /* 使用webkit内核的浏览器 */
          input:-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本4-18 */
          input::-moz-placeholder {
            color: #999999;
          }
          /* Firefox版本19+ */
          input:-ms-input-placeholder {
            color: #999999;
          } /* IE浏览器 */
        }

        .promptInput2 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 80%;
          height: 50px;
          line-height: 50px;
          box-sizing: border-box;
          background: #f5f5f5;
          border-radius: 5px;
          // margin-bottom: 15px;

          span {
            width: 100%;
            height: 100%;
          }
          .span_tw {
            color: rgb(153, 153, 153) !important;
          }
          .promptInputValue {
            width: 100%;
            height: 100%;
            padding-left: 13px;
            box-sizing: border-box;
            border: none;
            background: #f5f5f5;
            border-radius: 6px 6px 6px 6px;
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
          }
        }

        .promptInput3 {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          background-color: #f7f8fa;
          height: 210px;
          border: 3px dotted #f5f5f5;
          position: relative;

          .wonderful {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #4d4d4d;

            img {
              width: 40px;
              height: 40px;
              border-radius: 50px;
              margin-bottom: 30px;
            }
          }

          .videoYulan {
            width: 100%;
            height: 100%;
            z-index: 999999;
            position: fixed;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            video {
              width: 80%;
              // object-fit: cover;
              height: 100%;
            }

            .guanbu {
              position: absolute;
              top: 5%;
              right: 5%;
              width: 20px;
              height: 20px;
              color: #fff;
              font-size: 12px;
              z-index: 999;
              border-radius: 10px;
              border: 1px solid #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .videoYulan2 {
            // cursor: pointer;
            // color: #ff5a25;
            // margin-left: 10px;
            position: absolute;
            bottom: 8px;
            right: 0px;
            left: 0px;
            margin: auto;
            font-size: 12px;
            color: #ff5a25;
            text-align: center;
            width: 100%;
          }
        }
      }

      .tabTis {
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #4d4d4d;
        line-height: 20px;
        margin-bottom: 50px;

        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
        }
      }
      .tabTis_1 {
        width: 100%;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #4d4d4d;
        line-height: 20px;
        // margin-bottom: 50px;

        img {
          width: 20px;
          height: 20px;
          margin-left: 10px;
        }
      }
      .view_guide {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff5a25;
        margin-top: 10px;
        text-decoration: underline;
        cursor: pointer;
      }
      .but {
        width: 140px;
        height: 40px;
        background: url("~@/assets/image/but.png") no-repeat;
        background-size: 100%;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        margin: auto;
        margin-top: 20px;
      }

      .but2 {
        width: 140px;
        height: 30px;
        text-align: center;
        font-size: 14px;
        color: #4d4d4d;
        margin: auto;
        margin-top: 10px;
      }
    }
  }
}

::v-deep .CountryCodeSelectorContainer {
  width: 100px;
  .arrow-down {
    width: 12px;
    height: 12px;
  }
}
.viewVideo {
  position: absolute;
  bottom: 30px;
  font-size: 12px;
  color: #4d4d4d;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
}
.reselect {
  position: absolute;
  bottom: 5px;
  font-size: 12px;
  margin: 0 auto;
  color: rgb(235, 196, 120);
  cursor: pointer;
}
.newShortBox {
  width: 600px;
  height: 308px;
  padding-top: 24px;
  padding-bottom: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 16px 16px 16px 16px;

  .list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;

    .lis {
      width: 100%;
      margin-bottom: 20px;
    }

    .lis:last-child {
      margin-bottom: 0px !important;
    }

    .lisCenten {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .lisText2 {
      display: flex;
      justify-content: space-between;
      width: 65%;
      margin: auto;
      font-size: 14px;

      span {
        color: #ff5a25;
      }
    }

    .ulst {
      width: 70%;
      margin: auto;

      ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-radius: 3px 3px 3px 3px;

        li {
          width: 33.3%;
          text-align: center;
          font-size: 14px;
          padding: 0 5px;
        }
        li:nth-child(2) {
          width: 30% !important;
        }
      }

      ul:nth-child(1) {
        background: #ff5a25;
        height: 30px;
        line-height: 30px;

        li {
          height: 100%;
          color: #fff;
        }
      }

      ul:nth-child(2) {
        background: #feffeb;
        font-size: 9.8px !important;
        line-height: 20px;
        margin-top: 10px;
        margin-bottom: 20px;

        li {
          color: #4e4e4e;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .lisText {
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e4e4e;
      line-height: 24px;
    }

    .but {
      width: 140px;
      height: 40px;
      background: url("~@/assets/image/but.png") no-repeat;
      background-size: 100%;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      margin: auto;
    }
  }
}
.show-link {
  color: #f97226;
  font-weight: 600 !important;
}
.show-link:hover {
  // font-weight: 600 !important;
  text-decoration: underline;
  cursor: pointer;
}
.link_not_allowed {
  cursor: not-allowed;
  color: #cccccc;
  font-weight: 600 !important;
}

.guide-container {
  padding: 16px;
  max-height: 80vh;
  overflow-y: auto;
}
.van-dialog {
  top: 50%;
  background-color: #000;
}
.generateHeatsBox {
  width: 960px;
  padding: 12px;
  box-sizing: border-box;
  background: #ffd123;
  border-radius: 16px 16px 16px 16px;
  .uls {
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    background: #fff;

    .titleH1 {
      width: 100%;
      font-size: 24px;
      color: #ff5a25;
      font-weight: 600;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 5px 0 15px 0;

      .right_icon {
        display: flex;
        align-items: center;
        div:nth-child(3) {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
        div:first-child {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #ff5a25;
          margin-left: 7px;
        }
      }

      .left_icon {
        display: flex;
        align-items: center;
        div:first-child {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(2) {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
        div:nth-child(3) {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background-color: #ff5a25;
          margin-right: 7px;
        }
      }
    }

    .textCentent {
      width: 100%;
      text-align: left;
      line-height: 26px;
      font-family: PingFang SC-Medium, PingFang SC;

      .color1 {
        color: #ff5a25;
      }
      .color2 {
        color: #999999;
      }

      .font_size1 {
        font-size: 18px;
      }
      .font_size2 {
        font-size: 14px;
      }

      .titleRed {
        width: 180px;
        height: 40px;
        line-height: 40px;
        background: #ff5a25;
        border-radius: 3px 3px 3px 3px;
        text-align: center;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 12px;
      }

      .but {
        width: 180px;
        height: 40px;
        line-height: 40px;
        background: #ff7e18;
        font-size: 20px;
        font-family: PingFang SC-Semibold, PingFang SC;
        border-radius: 3px 3px 3px 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        margin: auto;
        cursor: pointer;
        img {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }
      }
    }
  }
}

.generateHeats {
  ::v-deep .van-overlay {
    z-index: 99999 !important;
  }
  ::v-deep .van-popup {
    z-index: 99999 !important;
  }
}
.cszg_table {
  margin-top: 20px;
  .table-wrap {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #fa772f;
    font-size: 16px;
    line-height: 22px;
    font-family: PingFang SC-Semibold, PingFang SC;
    color: #666;

    th {
      border: 1px solid #fa772f;
      padding: 10px;
      font-weight: 600;
    }

    td {
      border: 1px solid #fa772f;
      padding: 10px;
      vertical-align: middle;
    }

    span {
      font-weight: 600;
    }
  }
}
.isChinese {
  /* 第一列 th/td 背景色 */
  thead tr th:first-child,
  tbody tr td:first-child {
    background-color: #fddec5;
  }

  /* 第二列 td 背景色（同一色系，稍微加深一点也可以按需要调） */
  tbody tr td:nth-child(2) {
    background-color: #fddec5;
  }

  /* 最后一列 th/td 背景色 */
  thead tr th:last-child,
  tbody tr td:last-child {
    background-color: #fddec5;
  }
}
.bxxq-table-wrap {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #fa772f;
  font-size: 16px;
  line-height: 28px;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #1a1a1a;
  td {
    border: 1px solid #fa772f;
    padding: 10px;
    vertical-align: middle;
    p {
      margin: 0 !important;
      color: #1a1a1a !important;
    }
  }
  /* 隐藏1 */
  tbody tr:nth-child(-n + 2) {
    background-color: #fdf4ec;
  }
  tbody tr:nth-child(n + 3) {
    background-color: #fddec5;
  }
}
.guidance-table-wrap {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #fa772f;
  font-size: 16px;
  line-height: 28px;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #1a1a1a;
  // 第一列的宽度固定80px
  td:first-child {
    width: 80px;
  }
  table-layout: fixed; // 让列宽生效

  // 第一行的第二、第三列宽度一致，扣除第一列 80px 后均分剩余宽度
  tbody tr:first-child td:nth-child(2),
  tbody tr:first-child td:nth-child(3) {
    width: calc((100% - 80px) / 2) !important;
  }
  td {
    width: 20%;
    border: 1px solid #fa772f;
    padding: 10px;
    vertical-align: middle;
    p {
      margin: 0 !important;
    }
  }
  .app_login {
    display: inline-block;
    margin-bottom: 10px;
    img {
      width: 50px;
    }
  }
  tbody tr:nth-child(-n + 5) {
    background-color: #fdf4ec;
  }
  tbody tr:nth-child(n + 6):nth-child(-n + 6) {
    background-color: #fddec5;
  }
  tbody tr:nth-child(n + 7):nth-child(-n + 10) {
    background-color: #f5bd8c;
  }
}
.awards-table-wrap {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #fa772f;
  font-size: 16px;
  line-height: 28px;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #666;
  // 第一列的宽度固定100px
  td:first-child {
    width: 100px !important;
  }
  td {
    // width: 20%;
    border: 1px solid #fa772f;
    padding: 10px;
    vertical-align: middle;
    p {
      margin: 0 !important;
    }
    img {
      max-width: 150px;
      max-height: 150px;
    }
  }
  .award-item {
    /* 沿底部对齐 */
    position: relative;
    vertical-align: bottom;
  }
  tbody tr {
    background-color: #fdf4ec;
  }
}
.materials-table-wrap {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid #fa772f;
  font-size: 16px;
  line-height: 28px;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: #666;
  margin-top: 20px;
  td {
    width: 50%;
    border: 1px solid #fa772f;
    padding: 10px;
    vertical-align: middle;
  }
  // tbody tr {
  //   background-color: #fdf4ec;
  // }
}
.guide-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  img {
    width: 120px;
    height: auto;
    // border-radius: 8px;
    object-fit: cover;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
}
</style>
